import React from "react";
import { cn } from "../../../utils/cn";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { Skeleton } from "../../../components/ui/skeleton";

export type StatCardProps = {
  label: string;
  /** Already-formatted headline value, e.g. "$1,200.00". */
  value: string;
  /** Optional pill items shown under the value, e.g. ["1,200 NGN", "14"]. */
  footer?: string[];
  masked?: boolean;
  loading?: boolean;
  className?: string;
};

const MASK = "•••••";

const StatCard = ({
  label,
  value,
  footer,
  masked = false,
  loading = false,
  className,
}: StatCardProps) => {
  return (
    <Card className={cn("shadow-sm", className)}>
      <CardHeader className="space-y-0 border-b p-4 pb-3">
        <CardTitle className="text-[13px] font-semibold uppercase tracking-wider text-primary">
          {label}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 pt-3">
        {loading ? (
          <Skeleton className="h-7 w-28" />
        ) : (
          <p className="font-sora text-[22px] font-bold text-foreground">
            {masked ? MASK : value}
          </p>
        )}

        {footer && footer.length > 0 && (
          <div className="mt-3 flex h-[26px] items-center justify-between gap-2 rounded-full bg-muted px-4 lgss:px-3">
            {loading ? (
              <Skeleton className="h-3 w-full" />
            ) : (
              footer.map((item, index) => (
                <React.Fragment key={item + index}>
                  {index > 0 && <span className="h-4 w-px bg-muted-foreground/50" />}
                  <span className="truncate text-[11px] font-bold text-muted-foreground">
                    {masked ? MASK : item}
                  </span>
                </React.Fragment>
              ))
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default StatCard;
